import { orderBy } from "lodash";

const LS_SCORE_KEY = 'ace-highscores';

interface IHighscore {
    date: Date
    score: number
    won: boolean
    playerId: number
}

export const highScorePosition = (playerId: number) => {
    const scores = orderBy(getHighscores(), ['score'], ['desc']);
    let position = 1;
    for (let score of scores) {
        if (score.playerId === playerId) {
            return position;
        }
        position++;
    }
    return 1;
}

export const saveHighscore = (playerId: number, score: number, won: boolean) => {
    const highScores = getHighscores().filter((highscore) => highscore.playerId !== playerId);
    highScores.push({
        date: new Date(),
        playerId,
        score,
        won
    });
    window.localStorage.setItem(LS_SCORE_KEY, JSON.stringify(highScores));
}

export const getHighscores = (): IHighscore[] => {
    try {
        return JSON.parse(window.localStorage.getItem(LS_SCORE_KEY) as string)
            .map((row: any) => {
                row.date = new Date(row.date);
                return row as IHighscore;
            });
    } catch (e) {
        // console.error(e);
        return [];
    }
}
